module.exports = {
    howler: [
        "res/sounds/bet-up",
        "res/sounds/bet-down",
        "res/sounds/credits",
        "res/sounds/winflow",
        "res/sounds/win",
        "res/sounds/bonus/background",
        "res/sounds/bonus/snake_eat",
        "res/sounds/bonus/snake_second_chance",
        "res/sounds/bonus/frog_sink",
        "res/sounds/bonus/superbonus_enter",
        "res/sounds/bonus/superbonus_background",
        "res/sounds/bonus/superbonus_lose",
        "res/sounds/bonus/superbonus_place_0",
        "res/sounds/bonus/superbonus_place_1",
        "res/sounds/bonus/superbonus_place_2",
        "res/sounds/bonus/superbonus_place_3",
        "res/sounds/bonus/superbonus_place_4",
        "res/sounds/bonus/creditsflow"

    ],
    //all other different resources (even those which configure the game logic) are able to be loaded with PIXI native loader:
    pixi: [

        "res/fonts/impact_font.xml",
        'res/fonts/mini_win_font.xml',

        "res/fonts/price-font.xml",

        "res/bonus_background_sea.png",
        "res/bonus_background_up.png",
        "res/bonus/bonus_0.json",
        "res/bonus/bonus_1.json",
        "res/bonus/bonus_leaves.json",
        "res/bonus/bonus_frog_0.json",
        "res/bonus/bonus_frog_1.json",
        "res/bonus/bonus_frog_2.json",
        "res/bonus/bonus_croco_0.json",
        "res/bonus/bonus_croco_1.json",
        "res/bonus/bonus_croco_2.json",

        "res/to_superbonus/superbonus_win_000.jpg",
        "res/to_superbonus/superbonus_win_001.jpg",
        "res/to_superbonus/superbonus_win_002.jpg",
        "res/to_superbonus/superbonus_win_003.jpg",
        "res/to_superbonus/superbonus_win_004.jpg",
        "res/to_superbonus/superbonus_win_005.jpg",
        "res/to_superbonus/superbonus_win_006.jpg",
        "res/to_superbonus/superbonus_win_007.jpg",
        "res/to_superbonus/superbonus_win_008.jpg",
        "res/to_superbonus/superbonus_win_009.jpg",
        "res/to_superbonus/superbonus_win_010.jpg",
        "res/to_superbonus/superbonus_win_011.jpg",
        "res/to_superbonus/superbonus_win_012.jpg",
        "res/to_superbonus/superbonus_win_013.jpg",

        "res/superbonus_background.jpg",
        "res/superbonus/superbonus_objects_0.json",
        "res/superbonus/superbonus_objects_1.json",
        "res/superbonus/superbonus_objects_2.json",
        "res/superbonus/superbonus_objects_3.json",
        "res/superbonus/superbonus_paintings_0.json",
        "res/superbonus/superbonus_paintings_1.json",
        "res/superbonus/waterman_0.json",
        "res/superbonus/waterman_1.json",
        "res/superbonus/waterman_2.json",

        "res/fonts/bonus_font.xml",
        "res/fonts/status-font.xml",
        "res/fonts/superbonus_font.xml"
    ]
};




//////////////////
// WEBPACK FOOTER
// ./res/resources.js
// module id = 27
// module chunks = 0